// extracted by mini-css-extract-plugin
export default {"message":"ReportsTable_message__M2xYr","phoneNumber":"ReportsTable_phoneNumber__iaqkh"};